import { useState } from "react";
import { useAttachments, useAddAttachment } from "../../hooks/useTasks";

/** Autorise uniquement http/https — bloque javascript:/data: (exfil du token
 * OIDC au clic). Le backend TM doit valider de même (client contournable). */
function safeHref(u: string | undefined): string | null {
  if (!u) return null;
  try {
    return ["http:", "https:"].includes(new URL(u).protocol) ? u : null;
  } catch {
    return null;
  }
}

/** Pièces jointes par lien (type=dam_ref · /{id}/attachments). Pas d'upload
 * binaire : aucun object store branché côté Todo, un lien externe est une
 * référence à un asset détenu ailleurs (le seul type non-inline accepté par la
 * contrainte CHECK task_attachments.type).
 * ponytail: upload direct quand un bucket S3/MinIO sera exposé par TM. */
export function AttachmentsSection({ taskId }: { taskId: string }) {
  const attachments = useAttachments(taskId);
  const add = useAddAttachment();
  const [uri, setUri] = useState("");
  const [name, setName] = useState("");

  const [error, setError] = useState("");

  const submit = () => {
    const u = uri.trim();
    if (!u) return;
    if (!safeHref(u)) {
      setError("URL invalide — seuls http:// et https:// sont acceptés.");
      return;
    }
    setError("");
    add.mutate({
      taskId,
      body: {
        type: "dam_ref",
        filename: name.trim() || u,
        storage_uri: u,
      },
    });
    setUri("");
    setName("");
  };

  return (
    <div className="detail-section">
      <div className="detail-section-title">Pièces jointes</div>
      {(attachments.data ?? []).map((a) => {
        const href = safeHref(a.storage_uri);
        return (
          <div key={a.id} className="prop-row" style={{ alignItems: "center" }}>
            <span className="prop-value">
              {href ? (
                <a
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "var(--accent)" }}
                >
                  📎 {a.filename || a.storage_uri}
                </a>
              ) : (
                <span style={{ color: "var(--ink-ghost)" }}>
                  📎 {a.filename || a.storage_uri}
                </span>
              )}
              <span className="tag" style={{ marginLeft: 6 }}>
                {a.type}
              </span>
            </span>
          </div>
        );
      })}
      {(attachments.data ?? []).length === 0 && (
        <div style={{ fontSize: 11.5, color: "var(--ink-ghost)" }}>
          Aucune pièce jointe.
        </div>
      )}

      <div className="quick-add" style={{ marginTop: 8, gap: 6 }}>
        <input
          value={uri}
          placeholder="URL du document…"
          onChange={(e) => setUri(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && submit()}
          aria-label="URL de la pièce jointe"
          style={{ flex: 1 }}
        />
        <input
          value={name}
          placeholder="Nom (optionnel)"
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && submit()}
          aria-label="Nom de la pièce jointe"
          style={{ width: 120 }}
        />
        <button className="btn" onClick={submit} disabled={!uri.trim()}>
          Joindre
        </button>
      </div>
      {error && (
        <div style={{ fontSize: 11.5, color: "var(--danger)", marginTop: 4 }}>
          {error}
        </div>
      )}
    </div>
  );
}
